const GenomeList = [
    "NLU",
      "NNU"
    ];
let GenomeNewList=[]
GenomeList.map(v=>{
    GenomeNewList.push({
        value:v,
        label:v
    })
})

export default GenomeNewList